module.exports = __webpack_public_path__ + "img/message-heart-circle.63c6a3ab.svg";